import script from "./HackathonAwards.vue?vue&type=script&setup=true&lang=ts"
export * from "./HackathonAwards.vue?vue&type=script&setup=true&lang=ts"

import "./HackathonAwards.vue?vue&type=style&index=0&id=2a261e12&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a261e12"]])

export default __exports__